import React from 'react'
import { Tag } from '../Tag'
import { TableTagsCellProps } from './TableTagsCell.types'
import styles from './TableTagsCell.module.scss'
import cl from 'classnames'

const TableTagsCellComponent = (props: TableTagsCellProps) => {
  const {
    tags
  } = props

  if (!tags) return null

  return (
    <div className={cl(styles.container, styles.scrollable)}>
      {!!tags && tags.split(',').map((tag, index) =>
        <Tag key={index} tag={tag.trim()} />
      )}
    </div>
  )
}

const TableTagsCell = TableTagsCellComponent
export { TableTagsCell }
